import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock, CreditCard, ShoppingCart } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { OrderBumps } from './OrderBumps';
import { UpsellPopup } from './UpsellPopup';
const BASE_PRICE = 11.99;
const BUMP1_PRICE = 10.99;
const BUMP2_PRICE = 9.99;
const CART_URLS = {
  base: 'https://rutinasimple.com//cart/52219237794073:1',
  bump1Only: 'https://rutinasimple.com//cart/52235856970009:1',
  bump2Only: 'https://rutinasimple.com//cart/52235858837785:1',
  bothBumps: 'https://rutinasimple.com//cart/52235860312345:1'
};
function getCheckoutUrl(bump1: boolean, bump2: boolean): string {
  if (bump1 && bump2) return CART_URLS.bothBumps;
  if (bump1) return CART_URLS.bump1Only;
  if (bump2) return CART_URLS.bump2Only;
  return CART_URLS.base;
}
function TotalBadge({
  total
}: {
  total: number;
}) {
  return <div className="bg-charcoal text-cream rounded-xl py-3 px-6 inline-flex items-center gap-3" data-id="element-148">
      <ShoppingCart className="w-5 h-5 text-gold" data-id="element-149" />
      <span className="font-bold text-lg" data-id="element-150">
        Tu total:{' '}
        <span className="text-gold text-2xl font-serif" data-id="element-151">
          ${total.toFixed(2)} USD
        </span>
      </span>
    </div>;
}
export function PricingSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const total = BASE_PRICE + (bump1 ? BUMP1_PRICE : 0) + (bump2 ? BUMP2_PRICE : 0);
  const handleCheckout = () => {
    if (!bump1 && !bump2) {
      setShowUpsell(true);
      return;
    }
    trackAddToCart();
    window.open(getCheckoutUrl(bump1, bump2), '_blank');
  };
  return <section id="pricing" className="py-14 md:py-24 px-6 bg-cream relative" data-id="element-152">
      <div className="max-w-3xl mx-auto text-center" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-6 md:p-12 rounded-3xl shadow-2xl border border-gold/20" data-id="element-154">
          <p className="text-lg md:text-xl text-charcoal/80 mb-6 md:mb-8 leading-relaxed" data-id="element-155">
            Normalmente, este conocimiento se vende en consultorios privados por
            más de $200. Pero hoy, como parte de nuestro lanzamiento mundial
            para democratizar la salud de la piel...
          </p>

          <h3 className="text-2xl font-bold mb-4 md:mb-6" data-id="element-156">
            Puedes llevarte el sistema completo por solo:
          </h3>

          <div className="text-6xl md:text-8xl font-bold text-gold font-serif mb-4 md:mb-6 drop-shadow-sm" data-id="element-157">
            $11<span className="text-2xl md:text-4xl" data-id="element-158">.99 USD</span>
          </div>

          <div className="mb-6" data-id="element-159">
            <TotalBadge total={total} data-id="element-160" />
          </div>

          <CTAButton className="w-full md:w-auto text-lg py-5 px-10 mb-6" onClick={handleCheckout} data-id="element-161">
            SÍ, QUIERO MI PIEL DE PORCELANA
          </CTAButton>

          <p className="text-charcoal/60 mt-4 mb-6 md:mb-8 font-medium" data-id="element-162">
            (Un solo pago. Acceso de por vida. Menos de lo que cuesta un café y
            un postre).
          </p>

          <OrderBumps bump1={bump1} setBump1={setBump1} bump2={bump2} setBump2={setBump2} data-id="element-163" />

          <div className="mt-6 mb-6" data-id="element-164">
            <TotalBadge total={total} data-id="element-165" />
          </div>

          <CTAButton className="w-full md:w-auto text-lg py-5 px-10 mb-6" onClick={handleCheckout} data-id="element-166">
            SÍ, QUIERO MI PIEL DE PORCELANA
          </CTAButton>

          <div className="flex items-center justify-center gap-4 text-sm text-charcoal/50 mt-6" data-id="element-167">
            <div className="flex items-center gap-1" data-id="element-168">
              <Lock className="w-4 h-4" data-id="element-169" /> Pago Seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-170">
              <CreditCard className="w-4 h-4" data-id="element-171" /> Acceso Inmediato
            </div>
          </div>
        </motion.div>
      </div>
      <UpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} data-id="element-172" />
    </section>;
}